import styled from '@emotion/styled';
import { BodyLarge, Center } from '../../styles';
import { shouldForwardProps } from '../../utils';
import { NotFoundSvg } from '../svgs';

const NotFoundBox = styled(Center)`
    min-height: 100vh;
    text-align: center;
`;

// const NotFoundBackground = styled(Image)`
//     position: absolute;
//     object-fit: cover;
//     top: 0;
//     height: inherit;
//     width: 100%;
//     border-radius: 12px;
// `;

const NotFoundText = styled(BodyLarge)`
    max-width: 400px;
    margin-bottom: ${({ theme }) => theme.spacing(5)};
`;

const NotFoundImage = styled(NotFoundSvg, shouldForwardProps)`
    position: absolute;
    object-fit: cover;
    top: 0;
    height: inherit;
    width: 100%;
    border-radius: 12px;
`;

export { NotFoundBox, NotFoundText, NotFoundImage };
